import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../spinners/Loading";
import FeatureLockedDialog from "../dialog/FeatureLockedDialog";
import usePlanGate from "../../hooks/usePlanGate";
import { selectEffectiveRoles } from "../../features/rolePreview/rolePreviewSlice";
import { ROLES_LIST } from "../../features/roles/roles.config";

export default function FeatureGateRoute({
  featureKey,
  fallbackPath,
  children,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const roles = useSelector(selectEffectiveRoles);
  // Mitglied-Rolle: hat Mitglied aber keine höherwertigen Rollen
  const isMitglied =
    Array.isArray(roles) &&
    roles.includes(ROLES_LIST.Mitglied) &&
    !roles.some((r) =>
      [
        ROLES_LIST.User,
        ROLES_LIST.Editor,
        ROLES_LIST.Admin,
        ROLES_LIST.SuperAdmin,
      ].includes(r)
    );
  const {
    isAllowed,
    isLoading,
    isDialogOpen,
    requiredPlanLabel,
    openDialog,
    closeDialog,
    goToUpgrade,
  } = usePlanGate(featureKey);

  React.useEffect(() => {
    if (!isLoading && !isAllowed && !isDialogOpen) {
      openDialog();
    }
  }, [isLoading, isAllowed, isDialogOpen, openDialog]);

  const handleClose = () => {
    closeDialog();
    const safeFallback =
      fallbackPath && fallbackPath !== location.pathname
        ? fallbackPath
        : "/dashboard/profil";
    navigate(safeFallback, { replace: true });
  };

  if (isLoading) {
    return <Loading />;
  }

  if (isAllowed) {
    return children;
  }

  return (
    <FeatureLockedDialog
      open={isDialogOpen}
      onClose={handleClose}
      onUpgrade={isMitglied ? undefined : goToUpgrade}
      upgradePlanLabel={isMitglied ? "" : requiredPlanLabel}
      memberView={isMitglied}
    />
  );
}

FeatureGateRoute.propTypes = {
  featureKey: PropTypes.string,
  fallbackPath: PropTypes.string,
  children: PropTypes.node.isRequired,
};

FeatureGateRoute.defaultProps = {
  featureKey: "",
  fallbackPath: "/dashboard/app",
};
